import { createSelector } from 'reselect';
import { Map } from 'immutable';

const selectFundingReport = (state) => state.get('fundingReport');

const makeSelectFundingReport = () =>
  createSelector(selectFundingReport, (state) => state.get('data', Map()));

const makeSelectFundingReportIsLoading = () =>
  createSelector(selectFundingReport, (state) => state.getIn(['network', 'loading']));

const makeSelectFundingReportError = () =>
  createSelector(selectFundingReport, (state) => state.getIn(['network', 'error']));

const makeSelectFundingReportSuccess = () =>
  createSelector(selectFundingReport, (state) => state.getIn(['network', 'success']));

const makeSelectFundingReportToDelete = () =>
  createSelector(selectFundingReport, (state) =>
    state.getIn(['deleteFundingReport', 'fundingReport']),
  );

const makeSelectInviteLink = () =>
  createSelector(selectFundingReport, (state) => state.getIn(['inviteLink', 'data']));

export {
  makeSelectFundingReport,
  makeSelectFundingReportError,
  makeSelectFundingReportIsLoading,
  makeSelectFundingReportSuccess,
  makeSelectFundingReportToDelete,
  makeSelectInviteLink,
};

export * from './delete/selectors';
export * from './list/selectors';
export * from './matches/selectors';
export * from './resendInvite/selectors';
